import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function resolveImageUrl(url) {
  return url?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
}
